import { composeClassNames } from "@faedev/editor-utils";
import NextImage from "next/image";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Jumbotron } from "react-bootstrap";
import Heading from "src/components/Heading";
import IntroductionInfo from "src/components/IntroductionInfo";
import constants from "src/constants";
import getYogaStyles from "src/functions/getYogaStyles";
import { sPlaylistHead } from "src/styles/sPlaylistHead.module.scss";
import { sPlaylistMotive } from "src/styles/sPlaylistMotive.module.scss";
import { ApiPlaylist } from "src/types/ApiPlaylist";

type Props = {
  className?: (string | string) | null | undefined;
  data: ApiPlaylist;
  style?: CSSProperties | null | undefined;
};

function PlaylistHead({ className, data, style }: Props) {
  const { locale: lang } = useRouter();
  const motiveImg = data?.motive;
  const Motive = motiveImg ? (
    <NextImage
      className={`playlist-motive-photo`}
      src={constants.Paths.imagesUrl + motiveImg?.image?.url}
      alt={motiveImg?.image?.alternativeText}
      layout="fill"
      objectFit={
        motiveImg?.width !== "fill" || motiveImg?.height !== "fill"
          ? "contain"
          : motiveImg?.object_fit
      }
    />
  ) : null;
  return (
    <Jumbotron
      className={composeClassNames([sPlaylistHead, className, "playlist-head"])}
      style={style}
    >
      {motiveImg ? (
        motiveImg?.image?.url ? (
          <div
            className={composeClassNames([sPlaylistMotive, "playlist-motive"])}
          >
            {Motive}
          </div>
        ) : null
      ) : null}
      {data ? (
        <div className="playlist-head-content">
          <Heading type="h1" title={data.title} />
          {data.practice_styles ? (
            <IntroductionInfo
              type={`links`}
              data={getYogaStyles(data.practice_styles, lang)}
            />
          ) : null}
        </div>
      ) : null}
    </Jumbotron>
  );
}

export default PlaylistHead;
